import {HostingDomainRecordData} from "./hostingDomainRecordData";
import {toUnicode} from "idna-uts46-hx";

export class HostingDomainsRecordMapper {
  public static map(record: any): HostingDomainRecordData {
    const hostingRecordData: HostingDomainRecordData = new HostingDomainRecordData();
    hostingRecordData.id = record.id;
    hostingRecordData.name = toUnicode(record.name);
    hostingRecordData.port = record.name;
    hostingRecordData.priority = record.priority;
    hostingRecordData.record_id = record.record_id;
    hostingRecordData.ttl = record.ttl;
    hostingRecordData.type = record.type;
    hostingRecordData.value = toUnicode(record.value);
    hostingRecordData.weight = record.weight;
    return hostingRecordData;
  }


}
